import log from "loglevel";

const logger = log.getLogger("app");

// Set log level based on environment
if (process.env.NODE_ENV === "development") {
  logger.setLevel("debug");
} else {
  logger.setLevel("silent");
}

const Log = {
  debug: (...args: any[]) => logger.debug(...args),
  info: (...args: any[]) => logger.info(...args),
  warn: (...args: any[]) => logger.warn(...args),
  error: (...args: any[]) => logger.error(...args),
  setLevel: (level: log.LogLevelDesc) => logger.setLevel(level),
};

export default Log;
